export const useInternalTransfersAction = 'use internal transfers action';
